(ns ui.view.card.risks.event
  (:require
   [re-frame.core :as rf]
   [ui.view.card.risks.model :as model]
   [ui.view.card.event :as common-event]
   [oops.core :as oops]
   [potpuri.core :as p]
   [frontend.controller.websocket.event :as ws]
   [ui.cofx.response :as response-cofx]))

(rf/reg-event-fx
 ::refetch-data
 [rf/trim-v]
 (fn [_ [ctx]]
   (let [event (common-event/create-fetch-card-data-event
                (assoc ctx :reset-entities? true))]
     {:fx [[:dispatch event]]})))

(rf/reg-fx
 ::show-modal
 (fn [modal-id]
   (if-let [el (oops/ocall js/document "getElementById" modal-id)]
     (oops/ocall el "showModal")
     (js/console.error "Modal not found" modal-id))))

(rf/reg-fx
 ::close-modal
 (fn [modal-id]
   (if-let [el (oops/ocall js/document "getElementById" modal-id)]
     (oops/ocall el "close")
     (js/console.error "Modal not found" modal-id))))

(rf/reg-event-fx
 ::open-delete-confirmation-modal
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as ctx} risk-id]]
   {:db (assoc-in db (into card-state-path [:delete-confirmation-entity-id]) risk-id)
    ::show-modal (model/delete-risk-confirmation-modal-id ctx)}))

(rf/reg-event-fx
 ::close-delete-confirmation-modal
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as ctx}]]
   {:db (p/dissoc-in db (into card-state-path [:delete-confirmation-entity-id]))
    ::close-modal (model/delete-risk-confirmation-modal-id ctx)}))

(rf/reg-event-fx
 ::delete-risk-success
 [rf/trim-v
  response-cofx/stale-response?]
 (fn [{:keys [db stale-reponse?]} [{:keys [card-state-path] :as ctx}]]
   (if stale-reponse?
     {::close-modal (model/delete-risk-confirmation-modal-id ctx)}
     {:db (p/dissoc-in db (into card-state-path [:delete-confirmation-entity-id]))
      :fx [[:dispatch [::refetch-data ctx]]
           [:dispatch [::common-event/close-entity-peek ctx]]
           [::close-modal (model/delete-risk-confirmation-modal-id ctx)]]})))

(rf/reg-event-fx
 ::delete-risk-error
 [rf/trim-v
  response-cofx/stale-response?]
 (fn [_cofx [_ctx resp]]
   ;; TODO: Handle error
   (js/console.error "Delete risk failed " resp)))

(rf/reg-event-fx
 ::delete-risk
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as ctx}]]
   (let [risk-id (get-in db (into card-state-path [:delete-confirmation-entity-id]))]
     {::ws/send {:id :entity/disable!
                 :body {:entity-id risk-id}
                 :on-success [::delete-risk-success ctx]
                 :on-error [::delete-risk-error ctx]}})))
